import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=6777d5ee&scoped=true&"
import script from "./HeaderBody.vue?vue&type=script&lang=ts&"
export * from "./HeaderBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777d5ee",
  null
  
)

export default component.exports